import { useCallback } from 'react';
import useManagerValue from './useManagerValue';
import useAppStateManager from './useAppStateManager';
export default name => {
  const manager = useAppStateManager();
  const value = useManagerValue({
    eventName: `${name}Change`,
    getFunction: useCallback(() => manager?.get?.(name), [name]),
    manager
  });
  return [value, manager?.getSetter?.(name)];
};